<template>
  <el-main class="workspace-content profile-page">
    <el-card shadow="never" class="profile-card">
      <div slot="header" class="profile-card__header">
        <span>{{ $t("个人资料") }}</span>
      </div>
      <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-width="auto"
          class="profile-form">
        <el-form-item :label="$t('姓名')" prop="name">
          <el-input v-model="form.name" :placeholder="$t('请输入姓名')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('手机号')" prop="phone">
          <el-input v-model="form.phone" :placeholder="$t('请输入手机号')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="saving" @click="handleSubmit">{{ $t("保存") }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </el-main>
</template>

<script>
import { t } from "@/i18n";
import app from '@/App';

export default {
  name: 'BrowserProfile',
  computed: {
    rules() {
      return {
        name: [
          { required: true, message: t("请输入姓名"), trigger: 'blur' },
          { min: 1, max: 50, message: t("姓名长度需在 1 到 50 个字符之间"), trigger: 'blur' }
        ],
        phone: [
          { validator: this.validatePhone, trigger: 'blur' }
        ]
      };
    },
  },
  data() {
    return {
      userId: null,
      form: {
        name: '',
        phone: ''
      },
      original: {
        name: '',
        phone: ''
      },
      saving: false,

    }
  },
  created() {
    this.fetchProfile();
  },
  methods: {
    validatePhone(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      if (!/^1\d{10}$/.test(value)) {
        callback(new Error(t("手机号格式不正确")));
        return;
      }
      callback();
    },
    async fetchProfile() {
      try {
        const res = await app.methods.getUser();
        const data = res.data || {};
        this.userId = data.userId;
        this.form.name = data.name || '';
        this.form.phone = data.phone || '';
        this.original = {
          name: this.form.name,
          phone: this.form.phone
        };
      } catch (error) {
        const message = error?.response?.data?.message || t("获取个人资料失败");
        this.$message.error(message);
      }
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        if (!this.userId) {
          this.$message.error(t("无法确定用户身份"));
          return;
        }
        if (this.form.name === this.original.name && this.form.phone === this.original.phone) {
          this.$message.info(t("信息未修改"));
          return;
        }
        this.saving = true;
        try {
          await app.methods.updateUserProfile(this.userId, {
            name: this.form.name,
            phone: this.form.phone
          });
          this.$message.success(t("保存成功"));
          this.original = {
            name: this.form.name,
            phone: this.form.phone
          };
          this.$root.$emit('user-updated');
        } catch (error) {
          const message = error?.response?.data?.message || t("保存失败");
          this.$message.error(message);
        } finally {
          this.saving = false;
        }
      });
    }
  }
}
</script>

<style scoped>
.profile-page {
  padding: 0;
  background: transparent;
  min-height: 0;
}

.profile-card {
  max-width: 620px;
  margin: 0;
}

.profile-card__header {
  color: var(--text-primary);
  font-size: 17px;
  font-weight: 600;
}

@media (max-width: 600px) {
  .profile-card {
    max-width: none;
  }
}
</style>
